<template>
  <div class="leaderboard-page">
    <HeaderNews
      subtitle="Noticias y contenido sobre Inteligencia Artificial"
      :showMobileMenu="true"
      @toggle-mobile-menu="showMobileSidebar = !showMobileSidebar"
    />

    <div class="leaderboard-layout">
      <Sidebar :class="{'sidebar--mobile-visible': showMobileSidebar}" @navigate="showMobileSidebar = false" />

      <div v-if="showMobileSidebar" class="mobile-overlay" @click="showMobileSidebar = false"></div>

      <div class="leaderboard-body">
        <main class="leaderboard-main">
          <div class="leaderboard-container">
            <h1 class="leaderboard-title">🏆 Ranking de modelos LLM</h1>
            <p class="leaderboard-description">
              Clasificación de los modelos de lenguaje más potentes según benchmarks. Elige una categoría para ver el ranking específico.
            </p>

            <!-- Mobile: mismo botón de filtros que en los feeds -->
            <button
              class="leaderboard-filters-btn"
              :class="{'leaderboard-filters-btn--active': showFilters}"
              :title="selected.label"
              :aria-label="selected.label"
              @click="showFilters = !showFilters"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="4" y1="6" x2="20" y2="6"/>
                <line x1="4" y1="12" x2="20" y2="12"/>
                <line x1="4" y1="18" x2="20" y2="18"/>
                <circle cx="8" cy="6" r="2" fill="currentColor"/>
                <circle cx="16" cy="12" r="2" fill="currentColor"/>
                <circle cx="12" cy="18" r="2" fill="currentColor"/>
              </svg>
              <span>{{ selected.label }}</span>
            </button>

            <div class="leaderboard-tabs" :class="{'leaderboard-tabs--visible': showFilters}">
              <button
                v-for="cat in categories"
                :key="cat.label"
                class="leaderboard-tab"
                :class="{'leaderboard-tab--active': cat === selected}"
                @click="selectCategory(cat)"
              >{{ cat.label }}</button>
            </div>

            <div class="leaderboard-frame-wrap">
              <div v-if="loading" class="leaderboard-loader">
                <div class="leaderboard-spinner"></div>
              </div>
              <iframe
                :src="`https://benchlm.ai/embed/leaderboard?${selected.params}&rows=10&theme=dark`"
                width="100%"
                height="612"
                frameborder="0"
                loading="lazy"
                :title="`BenchLM Leaderboard - ${selected.label}`"
                class="leaderboard-frame"
                @load="loading = false"
              ></iframe>
            </div>
            <p class="leaderboard-credit">
              <a href="https://benchlm.ai" target="_blank" rel="noopener">LLM benchmark leaderboard</a> by BenchLM.ai
            </p>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNews from '../components/HeaderNews.vue';
import Sidebar from '../components/Sidebar.vue';
import Footer from '../components/Footer.vue';

export default {
  name: 'Leaderboard',
  components: { HeaderNews, Sidebar, Footer },
  data() {
    // Parámetros tal cual los da BenchLM: algunas categorías no llevan mode
    const categories = [
      { label: 'General', params: 'mode=bench-align-v5' },
      { label: 'Programación', params: 'category=coding&mode=bench-align-v5' },
      { label: 'Agentes', params: 'category=agentic&mode=bench-align-v5' },
      { label: 'Razonamiento', params: 'category=reasoning' },
      { label: 'Conocimiento', params: 'category=knowledge&mode=bench-align-v5' },
      { label: 'Multimodal', params: 'category=multimodalGrounded' },
      { label: 'Seguir instrucciones', params: 'category=instructionFollowing' },
      { label: 'Multilingüe', params: 'category=multilingual' },
      { label: 'Matemáticas', params: 'category=math' }
    ];
    return { showMobileSidebar: false, categories, selected: categories[0], loading: true, showFilters: false };
  },
  methods: {
    selectCategory(cat) {
      this.showFilters = false;
      if (cat === this.selected) return;
      this.selected = cat;
      this.loading = true;
    }
  }
};
</script>

<style scoped>
.leaderboard-page {
  min-height: 100vh;
  background: #0e1217;
  color: #e1e7ef;
  display: flex;
  flex-direction: column;
}

.leaderboard-layout {
  display: flex;
  flex: 1;
  position: relative;
}

.leaderboard-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 240px; /* Ancho del sidebar */
  min-height: calc(100vh - 57px);
}

.leaderboard-main {
  flex: 1;
  padding: 24px 20px 80px;
}

.leaderboard-container {
  max-width: 1000px;
  margin: 0 auto;
}

.leaderboard-title {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px;
  color: #e1e7ef;
}

.leaderboard-description {
  color: #d1d9e3;
  margin: 0 0 20px;
}

.leaderboard-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}

.leaderboard-filters-btn {
  display: none;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin-bottom: 12px;
  background: #1c2127;
  border: 1px solid #2d333b;
  border-radius: 8px;
  color: #a0aec0;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
}

.leaderboard-filters-btn--active {
  background: #262c34;
  border-color: #4a9eff;
  color: #e1e7ef;
}

.leaderboard-tab {
  padding: 5px 10px;
  background: #1c2127;
  border: 1px solid #2d333b;
  border-radius: 8px;
  color: #a0aec0;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}

.leaderboard-tab:hover,
.leaderboard-tab--active {
  background: #262c34;
  border-color: #4a9eff;
  color: #e1e7ef;
}

.leaderboard-frame-wrap {
  position: relative;
}

.leaderboard-loader {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(14, 18, 23, 0.75);
  border-radius: 12px;
}

.leaderboard-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #2d333b;
  border-top-color: #4a9eff;
  border-radius: 50%;
  animation: leaderboard-spin 0.8s linear infinite;
}

@keyframes leaderboard-spin {
  to { transform: rotate(360deg); }
}

.leaderboard-frame {
  display: block;
  border-radius: 12px;
  border: 1px solid #2d333b;
}

.leaderboard-credit {
  font-size: 12px;
  text-align: right;
  margin-top: 4px;
  color: #9ca3af;
}

.leaderboard-credit a {
  color: #4a9eff;
}

.mobile-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 400;
  backdrop-filter: blur(4px);
}

.sidebar--mobile-visible {
  left: 0 !important;
}

@media (max-width: 768px) {
  .mobile-overlay {
    display: block;
  }

  .leaderboard-body {
    margin-left: 0;
  }

  .leaderboard-main {
    padding: 16px 12px 60px;
  }

  .leaderboard-filters-btn {
    display: flex;
  }

  .leaderboard-tabs {
    display: none;
  }

  .leaderboard-tabs--visible {
    display: flex;
  }
}

/* En pantallas angostas la tabla de BenchLM mide ~1000px: se da altura completa
   para no depender del scroll interno del iframe, que falla en táctil */
@media (max-width: 540px) {
  .leaderboard-frame {
    height: 1020px;
  }
}
</style>
